import React from "react";

const Step = ({ name, index, active, chStep, disabled, moreThanTablet }) => {
  return (
    <div
      className="step flex flex-row items-center text-sm font-semibold md:mb-3 cursor-pointer"
      onClick={disabled ? () => {} : () => chStep(index - 1)}
    >
      <div
        className={`num w-12 h-12 rounded-full border-2 ${
          active ? "border-red" : "border-grey-lighter"
        } text-red flex items-center justify-center md:bg-transparent bg-white`}
      >
        {index}
      </div>
      {moreThanTablet ? (
        <div
          className={`title ml-8  ${
            !disabled ? "hover:text-red" : ""
          } text-grey-darkest`}
        >
          {name}
        </div>
      ) : null}
    </div>
  );
};

export default Step;
